import { render, staticRenderFns } from "./SumCodTable.vue?vue&type=template&id=2ea6cfba&"
import script from "./SumCodTable.vue?vue&type=script&lang=js&"
export * from "./SumCodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports